<template>
  <!-- 首页 -->
  <div class="index_page">
    <!-- 导航菜单 -->
    <div class="nav_menu">
      <div class="logo" :class="{ logo_hidden: nav_collapse }">
        <!-- <transition name="move" mode="out-in">
                        <i class='el-icon-s-fold icon' v-if='!nav_collapse' @click="nav_collapse=true"></i>
                    </transition> -->
        <transition name="move" mode="out-in">
          <h2 v-if="!nav_collapse" @click="nav_collapse = true">
            后台管理系统
          </h2>
        </transition>
        <img
          v-if="nav_collapse"
          src="@/assets/img/logo.svg"
          alt=""
          @click="nav_collapse = false"
        />
      </div>
      <div class="menu_box">
        <el-menu
          :default-active="onRoutes"
          class="el-menu-vertical-demo"
          :collapse="nav_collapse"
          :unique-opened="true"
          router
          background-color="#E7EBF1"
          text-color="#525F7F"
          :default-openeds="openeds"
          active-text-color="#6772E5"
        >
          <template v-for="item in showNavList">
            <!-- 有二级菜单 -->
            <template v-if="item.child">
              <el-submenu :index="item.key" :key="item.key">
                <!-- 一级 -->
                <template slot="title">
                  <i
                    :style="
                      $route.meta.type == item.key ? 'color: #525F7F' : ''
                    "
                    class="iconfont"
                    :class="item.icon"
                  ></i>
                  <span
                    slot="title"
                    :style="
                      $route.meta.type == item.key ? 'font-weight:600' : ''
                    "
                    >{{ item.name }}</span
                  >
                </template>
                <!-- 二级 -->
                <template v-for="childItem in item.child">
                  <!-- <el-submenu :index="childItem.url" :key="childItem.url" v-if="childItem.child" >
                                            <template slot="title">{{ childItem.name }}</template>
                                        </el-submenu> -->
                  <el-menu-item :index="childItem.url" :key="childItem.url">
                    <i
                      :style="
                        $route.path == '/' + childItem.url
                          ? 'color: #606060'
                          : ''
                      "
                      class="iconfont"
                      :class="childItem.icon"
                    ></i>
                    <span
                      slot="title"
                      :style="
                        $route.path == '/' + childItem.url
                          ? 'font-weight:600'
                          : ''
                      "
                      >{{ childItem.name }}</span
                    >
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
            <!-- 没有二级菜单 -->
            <template v-else>
              <el-menu-item :index="item.url" :key="item.url">
                <i
                  :style="$route.path == '/' + item.url ? 'color: #606060' : ''"
                  class="iconfont"
                  :class="item.icon"
                ></i>
                <span
                  slot="title"
                  :style="
                    $route.path == '/' + item.url ? 'font-weight:600' : ''
                  "
                  >{{ item.name }}</span
                >
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
    </div>
    <!-- 页面内容 -->
    <div class="content_main">
      <div class="head">
        <div v-if="showNavList.length != 0">{{ route_name }}</div>
        <div v-else></div>
        <div class="user_info" @click="loginOut">
          <span>{{ username || "注销登陆" }}</span>
          <ul class="close">
            <li></li>
            <li></li>
          </ul>
        </div>
      </div>
      <div class="content_box">
        <div v-if="contentShow">
          <transition name="move" mode="out-in">
            <keep-alive>
              <router-view v-if="showNavList.length != 0"></router-view>
              <div class="null_page" v-else>没有可操作的内容</div>
            </keep-alive>
          </transition>
        </div>
        <div class="info_hint" v-load="infoLoading" v-if="infoLoading">
          <p>正在获取登陆信息...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infoLoading: false,
      contentShow: false,
      nav_collapse: false,
      showNavList: [], // 有权限显示的导航栏
      route_name: "",
      username: "",
      routers: [],
      openeds: [],
      menuType: {
        aUser: { icon: "el-icon-user-solid", name: "用户管理" },
        bCompany: { icon: "el-icon-office-building", name: "公司管理" },
        cClass: { icon: "el-icon-s-grid", name: "分类专题" },
        dSite: { icon: "el-icon-guide", name: "定向站点管理" },
        eKeyWord: { icon: "el-icon-s-opportunity", name: "关键词库管理" },
        fUserManage: { icon: "icon-kehuguanli", name: "客户管理" },
        updateJ: {
          icon: "el-icon-user-solid",
          name: "更新日志"
        }
      }
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/index", "");
    }
  },
  watch: {
    $route(newValue, oldValue) {
      this.setTags(newValue);
    }
  },
  created() {
    this.$router.options.routes.forEach(val => {
      if (val.path == "/index") this.routers = val.children;
    });
    this.getUserInfo();
  },
  beforeDestroy() {},
  methods: {
    // 获取用户信息
    getUserInfo() {
      this.infoLoading = true;
      let token = localStorage.getItem("token");
      this.$store.state.isAdmin = false;
      this.$store.state.companyId = "";
      this.$http({
        url: this.$api.login_userInfo,
        data: { token }
      })
        .then(res => {
          if (res.code == 0) {
            this.showNavList = [];
            this.$store.state.companyId = res.data.companyId;
            this.username = res.data.username;
            let permission = res.data.permission;
            let menuObj = {
              aUser: [],
              bCompany: [],
              cClass: [],
              dSite: [],
              eKeyWord: [],
              other: []
            };
            permission.forEach(val => {
              // 是否管理员-勾中为是；管理员能查看全公司信息
              if (val.frontendValue == "sys:syzh:backstage:isAdmin")
                this.$store.state.isAdmin = true;
              // 匹配各页面权限
              this.routers.forEach(routeIem => {
                if (val.frontendValue == routeIem.meta.authorName) {
                  routeIem.meta.authority = true;
                  let menuName = this.menuType[routeIem.meta.type];
                  if (menuName) {
                    if (menuObj[routeIem.meta.type]) {
                      menuObj[routeIem.meta.type].push({
                        icon: routeIem.icon,
                        name: routeIem.name,
                        url: routeIem.path.slice(1)
                      });
                    } else {
                      menuObj[routeIem.meta.type] = [
                        {
                          icon: routeIem.icon,
                          name: routeIem.name,
                          url: routeIem.path.slice(1)
                        }
                      ];
                    }
                  } else {
                    menuObj["other"].push({
                      icon: routeIem.icon,
                      name: routeIem.name,
                      url: routeIem.path.slice(1)
                    });
                  }
                }
              });
            });
            this.showNavList = [];
            Object.keys(menuObj).forEach(key => {
              if (key == "other") {
                menuObj[key].forEach(val => {
                  this.showNavList.push(val);
                });
              } else {
                this.showNavList.push({
                  icon: this.menuType[key].icon,
                  name: this.menuType[key].name,
                  key,
                  child: menuObj[key]
                });
              }
            });
            this.infoLoading = false;
            this.contentShow = true;
            // 打开第一个路由
            if (
              this.showNavList.length != 0 &&
              this.$route.fullPath == "/index"
            ) {
              let url = "";
              if (this.showNavList[0].url) {
                url = "/" + this.showNavList[0].url;
              } else {
                url = "/" + this.showNavList[0].child[0].url;
                this.openeds = [this.showNavList[0].key];
              }
              this.$router.replace(url);
              this.setTags(this.$route);
            } else {
              let fullPath = this.$route.fullPath;
              this.showNavList.forEach(val => {
                if (val.child) {
                  val.child.forEach(child => {
                    if (child.url == fullPath.slice(1)) {
                      this.openeds = [val.key];
                      this.setTags(this.$route);
                    }
                  });
                } else {
                  this.setTags(this.$route);
                }
              });
            }
          } else {
            this.infoLoading = false;
            this.$hint("用户权限获取失败，请重新登陆！", "err");
            localStorage.clear();
            this.$router.replace("/login");
          }
        })
        .catch(err => {
          this.infoLoading = false;
        });
    },
    // 设置标签
    setTags(route) {
      this.route_name = route.name;
    },
    // 退出登陆
    loginOut() {
      this.$confirm("确认退出登陆吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: "false",
        cancelButtonClass: "loginout_close",
        confirmButtonClass: "loginout_confirm"
      }).then(() => {
        let token = localStorage.getItem("token");
        this.$http({
          url: this.$api.loginOut,
          data: { token }
        }).then(res => {});
        // localStorage.removeItem('token');
        localStorage.clear();
        this.$router.replace("/login");
        this.$hint("您已退出登陆");
      });
    }
  }
};
</script>

<style lang="less" scoped>
.index_page {
  width: 100vw;
  height: 100vh;
  color: #525f7f;
  display: flex;
  background: #e7ebf1;
  overflow: hidden;
  .nav_menu {
    height: 100%;
    display: flex;
    flex-direction: column;
    .logo {
      width: 180px;
      height: 60px;
      font-size: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      transition: all 0.5s;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        .icon {
          opacity: 1;
        }
      }
      .icon {
        font-size: 22px;
        margin-right: 20px;
        transform: translateY(1px);
        cursor: pointer;
        opacity: 0.7;
        transition: all 0.5s;
      }
      > img {
        width: 35px;
        cursor: pointer;
      }
    }
    .logo_hidden {
      width: 64px;
    }
    .menu_box {
      height: 0;
      flex: 1;
      padding-bottom: 20px;
      box-sizing: border-box;
      overflow-y: scroll;
    }
    .el-menu {
      border: none;
      .el-menu-item:hover {
        background: #f6f9fc !important;
      }
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 180px;
      min-height: 400px;
    }
  }
  .content_main {
    flex: 1;
    width: 0;
    height: 100%;
    min-width: 800px;
    padding: 10px 15px 0px 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .head {
      width: 100%;
      height: 50px;
      background: #fff;
      border-radius: 6px;
      margin-bottom: 10px;
      box-shadow: -3px 5px 5px 0px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 20px;
      box-sizing: border-box;
      font-size: 14px;
      position: relative;
      z-index: 99;
      .out {
        cursor: default;
        &:hover {
          color: #333;
        }
      }
      .user_info {
        height: 100%;
        font-size: 13px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        cursor: default;
        .close {
          width: 0px;
          height: 15px;
          margin-left: 10px;
          position: relative;
          transition: all 0.5s;
          > li {
            width: 100%;
            height: 2px;
            background: #525f7f;
            border-radius: 10px;
            position: absolute;
            transition: all 0.5s;
            left: 0;
            &:nth-child(1) {
              top: 5px;
            }
            &:nth-child(2) {
              bottom: 5px;
            }
          }
        }
        &:hover {
          .close {
            width: 15px;
            > li {
              &:nth-child(1) {
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%) rotate(45deg);
              }
              &:nth-child(2) {
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%) rotate(-45deg);
              }
            }
          }
        }
      }
    }
    .content_box {
      width: 100%;
      height: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-bottom: 15px;
      box-sizing: border-box;
      > div {
        height: 0;
        flex: 1;
        background: #fff;
        border-radius: 6px;
        box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.1);
      }
      .info_hint {
        display: flex;
        align-items: center;
        justify-content: center;
        > p {
          position: relative;
          top: 30px;
          z-index: 999;
          font-size: 13px;
          letter-spacing: 1px;
        }
      }
    }
    .content_box::-webkit-scrollbar {
      width: 3px;
      background-color: rgba(0, 0, 0, 0);
    }
    .content_box::-webkit-scrollbar-thumb {
      background-color: rgba(82, 95, 127, 0.4);
      border-radius: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue